export default __webpack_public_path__ + "static/media/TheElements _09.f13be063.png";